<template lang="html">
  <section class="actionbar menu_wkBox_back_box" :class="className">
    <div class="action-list">
      <ul class="action-others">
        <slot name="icons"> </slot>
      </ul>
      <slot name="buttons"> </slot>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    status: {
      type: [String, Number],
      default: 0
    },
    className: {
      type: String,
      default: '' // wait-pay 待支付，样式不同
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.actionbar {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  // height: rem(98px);
  z-index: 100;
  background: #fff;

  .action-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: rem(10px) 0;
    overflow: hidden;
    @include border(top);
    &::before {
      top: -1px;
    }
  }
  .action-others {
    display: flex;
    align-items: center;

    flex: none;
    li {
      flex: 1;
      flex-basis: 0;
      width: rem(98px);
      margin-right: rem(20px);
      // line-height: rem(98px);
      text-align: center;
      .iconfont {
        display: block;
        font-size: rem(48px);
      }
      span {
        display: block;
        font-size: rem(22px);
        // margin-top: rem(5px);
      }
    }
  }
  .btns {
    display: block;
    flex: 1;
    flex-basis: 0;
    text-align: center;
    line-height: rem(98px);
    color: #fff;
    font-size: rem(32px);
  }
  .btn-pink {
    background-image: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
  }
  .btn-grey {
    background: #999;
  }
  .btn-ccc {
    background: #cccccc;
  }
  .btn-cancel {
    background: #505050;
  }
  .btn-gray_b {
    border: rem(2px) solid #cccccc;
    a {
      color: #262626 !important;
    }
  }
}
.rearAction {
  display: flex;
  padding-left: rem(20px);
  padding-right: rem(20px);
  justify-content: space-between;
  align-items: center;
  .action-list {
    width: 100%;
    .contact-wx {
      margin-right: rem(20px);
      a {
        line-height: rem(66px);
        height: rem(66px);
      }
    }
    .consult {
      a {
        line-height: rem(70px);
        height: rem(70px);
      }
    }
  }
}
</style>
